import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

const PageLoader = () => {
  return <CircularProgress color="primary" size={50} thickness={4} />;
};

export default PageLoader;
